import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import { IQuestionBankSection } from 'interfaces/questionBank'
import Section from './section'

const List = () => {
  const dispatch = useAppDispatch()
  const data = useAppSelector(slices.questionBank.data)

  const onDragEnd = (result: any) => {
    const { destination, source } = result

    if (!destination || destination.index === source.index) {
      return
    }

    const newSections = reorder(data.sections, source.index, destination.index)
    dispatch(slices.questionBank.updateSectionsOrder(newSections))
  }

  const reorder = (
    list: IQuestionBankSection[],
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {data.sections.map((section, index) => (
              <Draggable
                key={index}
                draggableId={index.toString()}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{ ...provided.draggableProps.style }}
                  >
                    <Section
                      key={index}
                      section={section}
                      provided={provided}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default List
